import { useEffect, useState } from 'react';
import { MemberLoginFormGroup, useFormFieldEffect, FormField } from '../..';
import { validateRequired } from '../../validators';

export interface MemberLoginFormFields {
  username: string | null;
  password: string | null;
}

export const useMemberLoginFormEffect = (): MemberLoginFormGroup => {
  const [isValid, setValid] = useState(false);
  const [isClean, setClean] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);

  const username = useFormFieldEffect('username', 'text', [validateRequired], {
    required: true,
  });

  const password = useFormFieldEffect('password', 'text', [validateRequired], {
    required: true,
  });

  const members = {
    username,
    password,
  };

  useEffect(() => {
    let valid = true;
    let clean = true;

    const formFields = members as any as { [key: string]: FormField };

    for (const i in formFields) {
      if (!formFields[i].isValid) {
        valid = false;
      }

      if (!formFields[i].isClean) {
        clean = false;
      }
    }

    if (isValid !== valid) {
      setValid(valid);
    }

    if (isClean !== clean) {
      setClean(clean);
    }
  }, [members, isClean, setClean, isValid, setValid]);

  const getFieldValues = (): MemberLoginFormFields => {
    return {
      username: (members.username.value as string) || null,
      password: (members.password.value as string) || null,
    };
  };

  const resetFieldValues = (clean = false) => {
    members.username.doReset(clean);
    members.password.doReset(clean);
  };

  return {
    isValid,
    isClean,
    isSubmitted,
    setValid,
    setClean,
    setSubmitted,
    getFieldValues,
    resetFieldValues,
    members,
  };
};
